import React from "react";
import t from "Utils/translation";
import sessionStore from "@/stores/session";

const TranslatedString = (props) => {
  let { children, subs } = props;

  const language = sessionStore.language;

  return <span dangerouslySetInnerHTML={{ __html: t(children, language, subs) }} />;
};

export default TranslatedString;
